export default __webpack_public_path__ + "static/media/image_shape.114dfba8.webp";